module.exports = __webpack_public_path__ + "8b7b51bd8415b8d5c64da47a07514ce9.png";